import React, { FC } from 'react';
import classNames from 'classnames';

import { Skeleton } from '../index';

import styles from './GridSkeleton.module.scss';

const sizes = [
  {
    width: 120,
    height: 10,
  },
  {
    width: 160,
    height: 10,
  },
  {
    width: 80,
    height: 10,
  },
];

type GridSkeletonsProps = {
  className?: string;
};

export const GridSkeletons: FC<GridSkeletonsProps> = ({ className }) => (
  <li className={classNames(styles.skeletonItem, className)}>
    <div className={styles.skeletonHeader}>
      <Skeleton width={24}
                height={27} />
      <Skeleton width={160}
                height={27}
                className={styles.secondItem} />
    </div>
    <div className={styles.wrapperBetting}>
      <div className={styles.matchDetails}>
        <Skeleton className={styles.skeletonMatch}
                  skeletonSizes={sizes} />
      </div>
      <div className={styles.rightCell}>
        <Skeleton width={116}
                  height={61} />
        <Skeleton width={116}
                  height={61} />
        <Skeleton width={116}
                  height={61} />
      </div>
      <div className={styles.rightEnd}>
        <Skeleton width={20}
                  height={10}
                  wrapperClassName={styles.rightEndItem} />
        <Skeleton width={20}
                  height={10}
                  wrapperClassName={styles.rightEndItem} />
      </div>
    </div>
  </li>
);
